import React from 'react';
import { PromptVariable } from '../../types';
import { VariableOfStringTypeFields } from './VariableOfStringTypeFields';
import { VariableOfListTypeItems } from './VariableOfListTypeItems';

export const VariableBox = ({
  variable,
  onUpdate,
}: {
  variable: PromptVariable;
  onUpdate: (newValue: PromptVariable) => void;
}) => {
  return (
    <div
      className="variables-table__variable-container"
      data-test="variables-table__variable-container"
    >
      <div className="variables-table__name-header" data-test="variables-table__name-header">
        <div>
          <span
            data-test="variables-table__name-header-text"
            className="text-capitalize growegy-font14--weight500 growegy-font--neutral900 growegy-font-em"
          >
            {variable.variableValue.name}
          </span>
        </div>
      </div>
      {variable.variableValue.type === 'string' && (
        <VariableOfStringTypeFields variable={variable} onUpdate={onUpdate} />
      )}
      {variable.variableValue.type === 'list' && (
        <VariableOfListTypeItems variable={variable} onUpdate={onUpdate} />
      )}
    </div>
  );
};
